import React from "react";
import { Grid, Typography } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import FeedIcon from "@mui/icons-material/Feed";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import MaterialCard from "../components/MaterialCard";

export default function Essentials() {
  return (
    <>
      <Typography variant="h2">Niezbędnik SFH</Typography>
      <Typography variant="body1">
        Znajdziesz tutaj najbardziej przydatne linki i materiały dotyczące SFH.
      </Typography>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 4 }}>
          <MaterialCard
            title="Szkolenie z Safe From Harm"
            href="https://edu.zhp.pl/enrol/index.php?id=47"
            icon={<SchoolIcon />}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <MaterialCard
            title="Zakładanie kont szkoleniowych dla osób bez maila ZHP"
            href="https://konta-sfh.zhp.pl/"
            icon={<PersonAddAltIcon />}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <MaterialCard
            title="SharePoint Safe From Harm"
            href="https://gkzhp.sharepoint.com/SitePages/Safe-From-Harm.aspx"
            icon={<InfoOutlineIcon />}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <MaterialCard
            title="Polityka Safe From Harm i materiały edukacyjne"
            href="https://cbp.zhp.pl/m?search=safe%20from%20harm"
            icon={<MenuBookIcon />}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <MaterialCard
            title="Formularz ewaluacyjny polityki Safe From Harm"
            href="https://forms.office.com/pages/responsepage.aspx?id=Ho024XU55kyJPfw1H9RNzU5VhILvpE9GuSovCYlkU89URjRRN0xIMEw1SVJYWllQTjFLTlBHWFVGMC4u&route=shorturl"
            icon={<FeedIcon />}
          />
        </Grid>
      </Grid>
    </>
  );
}
